import { IonButton, IonInput, IonItem, IonLabel } from "@ionic/react";
import * as React from "react";

import styles from "./EditPasswordField.module.scss";

export interface EditPasswordFieldProps {
  isInputPasswordMode: boolean;
  value: string;
  error: string;
  changeInputMode: () => void;
  onChange: (e: any) => void;
  cancel: () => void;
}

export const EditPasswordField = (props: EditPasswordFieldProps) => {
  return (
    <>
      <IonItem>
        <IonLabel>パスワード</IonLabel>
        {props.isInputPasswordMode && (
          <>
            <IonInput
              name="password"
              type="password"
              autocomplete="new-password"
              onIonChange={props.onChange}
              className={styles.input}
            />
            <IonButton
              className={styles.changeButton}
              fill="outline"
              onClick={props.cancel}
            >
              キャンセル
            </IonButton>
          </>
        )}
        {!props.isInputPasswordMode && (
          <>
            <IonLabel className={styles.attributeValue} slot="end">
              *****
            </IonLabel>
            <IonButton
              className={styles.changeButton}
              fill="outline"
              slot="end"
              onClick={props.changeInputMode}
            >
              変更する
            </IonButton>
          </>
        )}
      </IonItem>
      <div className={props.error && styles.invalidFeedback}>{props.error}</div>
    </>
  );
};

export default EditPasswordField;
